module.exports = "https://deal-img.imgix.net/consumer/modern/jet.1edb48ae.png";